import * as React from 'react';
import { Svg } from '../../Svg';

const CloseIcon: React.FunctionComponent = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="white" />
      <path
        d="M6.375 6L18 17.625"
        stroke="#373B40"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.625 6L6 17.625"
        stroke="#373B40"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default CloseIcon;
